import { Button } from "@progress/kendo-react-buttons"
import { UserResponse, ValidationErrorType, validationError } from '../../../Common';
import { SurveyEngine_Models_AuthenticateUser, SurveyEngine_Models_AuthenticateUserResponse, SurveyEngine_Models_DispoSelect, SurveyEngine_Models_Block, SurveyEngine_Models_Command, SurveyEngine_Models_DynamicResponse, SurveyEngine_Models_GetResponse, SurveyEngine_Models_GetResponseResponse, SurveyEngine_Models_GetValue, SurveyEngine_Models_GetValueResponse, SurveyEngine_Models_MultiResponseGrid, SurveyEngine_Models_MultiResponseResponse, SurveyEngine_Models_Scale, SurveyEngine_Models_RecordMessage, SurveyEngine_Models_RecordMessageResponse, SurveyEngine_Models_ScaleMatrix, SurveyEngine_Models_ScaleMatrixResponse, SurveyEngine_Models_FileUpload, SurveyEngine_Models_Ranking, SurveyEngine_Models_RankingResponse } from '../../../api';
import { useSurveyCtx, useSurveyCtxDispatch, useUserResponseCtx } from '../../../Context/SurveyContext';
import { useBlockCtx, useBlockDispatchCtx } from '../../../Context/BlockContext';


interface NextButtonProps {
  text: string,
  getNextQuestionCommand: (surveyInstanceID: string, payLoad: UserResponse) => void
}

export const NextButton = (props: NextButtonProps) => {
  const surveyCtx = useSurveyCtx();
  const surveyCtxDispatch = useSurveyCtxDispatch();
  let userResCtx = useUserResponseCtx();
  const blockCTX = useBlockCtx()
  const blockDispatchCtx = useBlockDispatchCtx();
  function ValidateResponse(command: SurveyEngine_Models_Command, response: UserResponse): boolean {
    switch (command.commandType) {
      case "Announce":
        {
          return true;
        }
      case "DispoSelect":
        {
          let currentCmd = command as SurveyEngine_Models_DispoSelect;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else
            return true;
        }
      case "DynamicResponse":
        {
          let currentCmd = command as SurveyEngine_Models_DynamicResponse;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else {
            return true;
          }
        }
      case "FileUpload":
        {
          let currentCmd = command as SurveyEngine_Models_FileUpload;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else {
            return true;
          }
        }
      case "Scale":
        {
          let currentCmd = command as SurveyEngine_Models_Scale;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else {
            return true;
          }
        }
      case "ScaleMatrix":
        {
          let currentCmd = command as SurveyEngine_Models_ScaleMatrix;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else {
            let currentResponse = response.find(r => r.commandIndex === currentCmd.commandIndex) as SurveyEngine_Models_ScaleMatrixResponse;
          if(currentResponse.answers?.length !== currentCmd.questions?.length)
            {
              let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
              surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
              return false;
            }
          else{
              return true;
            }
          }
        }
      case "Ranking":
        {
          let currentCmd = command as SurveyEngine_Models_Ranking;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else {
            let currentResponse = response.find(r => r.commandIndex === currentCmd.commandIndex) as SurveyEngine_Models_RankingResponse;
          if(currentResponse.answers?.length !== currentCmd.questions?.length)
            {
              let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
              surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
              return false;
            }
          else{
              return true;
            }
          }
        }
      case "GetResponse":
        {
          let currentCmd = command as SurveyEngine_Models_GetResponse;
          if (response.length === 0) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          else {
            let currentResponse = response.find(r => r.commandIndex === currentCmd.commandIndex) as SurveyEngine_Models_GetResponseResponse;
            let currentResponseIndex = currentCmd.answers?.find(a => a.id === currentResponse.selectedId);
            if (currentResponseIndex?.isOpenEnded) {
              if (currentResponse.otherValue && currentResponse.otherValue.length >= 0)
                return true
              else {
                let error: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
                surveyCtxDispatch({ type: "addValidationError", value: error })
                return false;
              }
            }
            else
              return true;
          }
        }
      case "GetValue":
        {
          let currentCmd = command as SurveyEngine_Models_GetValue;
          let currentResponse = response.find(r => r.commandIndex === currentCmd.commandIndex) as SurveyEngine_Models_GetValueResponse;
          if (currentResponse)
            return true;
          else {
            let error: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: error })
            return false;
          }
        }
      case "MultiResponse":
        {
          let currentCmd = command as SurveyEngine_Models_MultiResponseGrid;
        if(response.length === 0){
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd })
            return false;
          }
          let multiResponse = response[0] as SurveyEngine_Models_MultiResponseResponse;
          let answerCount = multiResponse.answerIds?.length;
          if (answerCount! < currentCmd.minResponses! || answerCount! > currentCmd.maxResponses!) {
            let errorCmd: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: errorCmd });
            return false;
          }
          return true;

        }
      case "Block":
        {
          let currentCmd = command as SurveyEngine_Models_Block;
          let isError: boolean = false;
          let childCommadHasError: boolean = false;
          if (currentCmd.keepOnPage) {
            currentCmd.commands?.forEach(cmd => {
              let cmdRes = response.find(r => r.commandIndex === cmd.commandIndex);
              if (!cmdRes) {
                let error: validationError = { commandIndex: cmd.commandIndex!, commandType: cmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
                surveyCtxDispatch({ type: "addValidationError", value: error })
                if (currentCmd.commandType === "Block")
                  blockDispatchCtx({ type: "BlockError", value: true })
                isError = true;
              }
              else {
                if (!ValidateResponse(cmd, [cmdRes])) {
                  childCommadHasError = true;
                }
                else {
                  let error: validationError = { commandIndex: cmd.commandIndex!, commandType: cmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
                  surveyCtxDispatch({ type: "removeValidationError", value: error })
                }
              }
            });

            if (childCommadHasError) {
              isError = true;
            }
            if (currentCmd.sumTo && currentCmd.sumTo > 0) {
              if (blockCTX.CurrentSumToValue !== currentCmd.sumTo) {
                isError = true;
              }
            }
            blockDispatchCtx({ type: "ResetCommandIndexFocus", value: true })
          }
          else
          {
            isError = true;
            let cmdRes = response.find(r => r.commandIndex === currentCmd.commands![blockCTX.currentIndex].commandIndex);
            if (!cmdRes) {
              let error: validationError = { commandIndex: currentCmd.commands![blockCTX.currentIndex].commandIndex!, commandType: currentCmd.commands![blockCTX.currentIndex].commandType!, errorType: ValidationErrorType.NO_RESPONSE }
              surveyCtxDispatch({ type: "addValidationError", value: error })
            }
            else{
              if(ValidateResponse(currentCmd.commands![blockCTX.currentIndex],[cmdRes!]))
              {
                surveyCtxDispatch({ type: "clearValidationError", value: [] })
                               
                if(blockCTX.currentIndex < (currentCmd.commands!.length - 1))
                {
                  blockDispatchCtx({ type: "UpdateIndex", value: blockCTX.currentIndex+1 })
                }
                else
                {
                  blockDispatchCtx({ type: "UpdateIndex", value: 0 })
                  isError = false; 
                }
              }
            }            
            
          }

          if (isError)
            return false;
          else
            return true;
        }
      case "AuthenticateUser":
        {
          let currentCmd = command as SurveyEngine_Models_AuthenticateUser;
          let currentResponse = response.find(r => r.commandIndex === currentCmd.commandIndex) as SurveyEngine_Models_AuthenticateUserResponse;
          if (currentResponse)
            return true;
          else {
            let error: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: error })
            return false;
          }
        }
      case "PlayValue":
      case "SLIDER":
      case "Video":
        {
          return true;
        }
      case "RecordMessage":
        {
          let currentCmd = command as SurveyEngine_Models_RecordMessage;
          let currentResponse = response.find(r => r.commandIndex === currentCmd.commandIndex) as SurveyEngine_Models_RecordMessageResponse;
          if (currentResponse)
            return true;
          else {
            let error: validationError = { commandIndex: currentCmd.commandIndex!, commandType: currentCmd.commandType!, errorType: ValidationErrorType.NO_RESPONSE }
            surveyCtxDispatch({ type: "addValidationError", value: error })
            return false;
          }
        }
      default:
        return false;
    }
  }
  function handleNextClick() {

    if (ValidateResponse(surveyCtx.NextQuestion, userResCtx.current)) {
      props.getNextQuestionCommand(surveyCtx.StartSurvey.surveyInstanceId!, userResCtx.current);
    }

  }
  if (surveyCtx.NextQuestion.commandType === "Announce" ||
    surveyCtx.NextQuestion.commandType === "PlayValue") {
    return (<Button
      name={props.text}
      aria-labelledby={`${surveyCtx.NextQuestion.commandType}_${surveyCtx.NextQuestion.commandIndex}`}
      className="theme-btn-next font-bold w-full md:w-auto"
      data-testid="next-button"
      onClick={handleNextClick}
      autoFocus
    >{props.text}</Button>)
  }
  else {
    return (<Button
      className="theme-btn-next font-bold w-full md:w-auto"
      data-testid="next-button"
      onClick={handleNextClick}
    >{props.text}</Button>)
  }
}